<template>
    <a-upload
            name="avatar"
            list-type="picture"
            class="avatar-uploader"
            :show-upload-list="false"
            action=""
            :customRequest="Upload"
            :before-upload="beforeUpload"
    >
        <div>
            <a-icon :type="loading>1 ? 'loading' : 'plus'"/>
            {{loading === 1?'上传成功':'选择上传文件'}}
        </div>
    </a-upload>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                loading: 0,
                image: null,
            }
        },
        methods: {
            //上传前验证和获取上传地址和验证信息
            beforeUpload(file) {
                return new Promise((resolve, reject) => {
                    // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                    // if (!isJpgOrPng) {
                    //     this.$message.error('请选择图片');
                    //     reject(false);
                    // }
                    const isLt2M = file.size / 1024 / 1024 < 200;
                    if (!isLt2M) {
                        this.$message.error('文件大小不能超过200MB!');
                        reject(false);
                    }
                    if (isLt2M) {
                        this.image = file;
                        resolve(true)
                    }
                });
            },
            Upload(file) {
                const data = new FormData();
                data.append('file', file.file);
                axios.post('http://49.4.66.163:8000/api/FileUpload/SingleFileUpload', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }).then(res => {
                    this.$emit('update:tempUrl',  res.data.completeFilePath)
                    this.loading = 1;
                }).catch(err => {
                    console.log(err);
                });
            },
        },
        props: {
            //存上传后的url
            tempUrl: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped>

</style>
